import config from '@utils/config/env';

export async function googleSignIn(redirectUrl = '') {
  window.open(
    `${config.backendBaseUrl}/v1/auth/google/signin?redirect=${redirectUrl}`,
    '_self'
  );
}
